
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SupplierInfoForm from "./supplier-info.vue";
import { SupplierFormCtrl } from "@/service/supplier-meta/common/SupplierFormCtrl";
import { StepForm } from "../../common/StepForm";
import { FormModel } from "@/service/common/entity/FormModel";
@Component({
  components: {
    SupplierInfoForm,
  },
})
export default class SupplierInfo extends StepForm {
  form: FormModel = {};
  created() {
    super.created();
    const supplierInfo = this.$refs.supplierInfoForm as SupplierInfoForm;
    supplierInfo?.recoverFormsData(this.data);
  }
  async validate() {
    const form = this.$refs.supplierInfoForm as SupplierFormCtrl;
    const res = await form.validate();
    return res;
  }
  getFormData() {
    const form = this.$refs.supplierInfoForm as SupplierFormCtrl;
    return form?.formData || {};
  }
  handleCacheRecovered() {
    this.$emit("cacheRecovered", this.getFormData());
  }
  handleFormDataChange(val: FormModel) {
    this.form = val;
  }
}
